import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import BuyingForm from '../form/BuyingForm'
import CustomEternityBandForm from '../form/CustomEternityBand'

const FormSection = ({ section, className = '' }) => {
  let componentProps = {}
  let FormComponent = React.Fragment
  switch (section.form) {
    case 'Sell us your Silver':
      componentProps = { type: 'silver' }
      FormComponent = BuyingForm
      break
    case 'Sell us your Watch':
      componentProps = { type: 'watches' }
      FormComponent = BuyingForm
      break
    case 'Sell us your Jewelry':
      componentProps = { type: 'jewelry' }
      FormComponent = BuyingForm
      break
    case 'Sell us your Diamonds':
      componentProps = { type: 'diamonds' }
      FormComponent = BuyingForm
      break
    case 'What are you looking to sell?':
      componentProps = {}
      FormComponent = BuyingForm
      break
    case 'Diamond Eternity Band':
      componentProps = {}
      FormComponent = CustomEternityBandForm
      break
  }
  return <FormComponent {...componentProps} className={className} />
  // return <section className={className}>
  //   This is a form section with ${section.form} fields and aside ${section.aside ? 'On' : 'Off'} / ${section.asideWidth}
  // </section>
}

FormSection.propTypes = {
  section: PropTypes.shape({
    form: PropTypes.string,
    aside: PropTypes.bool,
    asideWidth: PropTypes.string,
  }),
  className: PropTypes.string,
}

FormSection.defaultProps = {
  section: {
    form: '',
    aside: false,
    asideWidth: '',
  },
  className: '',
}

export const query = graphql`
  fragment FormSection on STRAPI__COMPONENT_SECTION_FORM {
    id
    form
    strapi_component
  }
`

export default FormSection
